import * as Yup from 'yup';

import i18n from '@/i18n';
import { VideoThemeClipTypeEnum } from '@/enums/VideoThemeClipEnum';

type ClipSelectionMap = Record<VideoThemeClipTypeEnum, unknown[]>;

export const hasRequiredThemeClips = (clipsByType: ClipSelectionMap) => {
  return (
    clipsByType[VideoThemeClipTypeEnum.INTRO].length > 0 &&
    clipsByType[VideoThemeClipTypeEnum.BACKGROUND].length > 0 &&
    clipsByType[VideoThemeClipTypeEnum.OUTRO].length > 0
  );
};

export const createCustomThemeValidation = Yup.object().shape({
  name: Yup.string()
    .required(i18n.t('nameRequired', { ns: 'common' }))
    .min(2, i18n.t('nameMin', { ns: 'common' }))
    .max(50, i18n.t('nameMax', { ns: 'common' }))
});
